import React from "react";
import { Dropdown, Button, Menu } from "antd";
import SC from "./style";

const DropdownMenu = (props) => {
  const {
    options = [],
    label,
    onChange = () => {},
    name,
    style = {},
    placement = "bottom",
    trigger = "hover",
    disabled = false,
  } = props;

  const handleItemClick = (item) => {
    if (onChange) {
      onChange(item, name);
    }
  };

  const menuItems = options.map((item) => (
    <Menu.Item
      className="menu-item"
      key={item.id}
      onClick={() => handleItemClick(item)}
      style={item.style}
    >
      {item.label}
    </Menu.Item>
  ));
  const menu = <SC.StyledMenu>{menuItems}</SC.StyledMenu>;
  return (
    <>
      {SC.GlobalStyles}
      {SC.MenuItemStyles}
      <Dropdown
        menu={options}
        dropdownRender={() => <div>{React.cloneElement(menu, {})}</div>}
        overlayStyle={{
          zIndex: 9000,
        }}
        placement={placement}
        arrow
        trigger={[trigger]}
        disabled={disabled}
        borderColor="none"
      >
        <Button style={style}>{label}</Button>
      </Dropdown>
    </>
  );
};
export default DropdownMenu;
